import { render, staticRenderFns } from "./RecentBackgrounds.vue?vue&type=template&id=5ab3e752&scoped=true"
import script from "./RecentBackgrounds.vue?vue&type=script&lang=js"
export * from "./RecentBackgrounds.vue?vue&type=script&lang=js"
import style0 from "./RecentBackgrounds.vue?vue&type=style&index=0&id=5ab3e752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab3e752",
  null
  
)

export default component.exports